export const ActionTypes = {
  INSERT_DEALERSHIP: "INSERT_DEALERSHIP",
  GET_DEALERSHIPLIST: "GET_DEALERSHIPLIST",
  DEALERSHIPDETAILS: "DEALERSHIPDETAILS",
  PLANDETAILS: "PLANDETAILS",
  COLLECTIONDETAILS: "COLLECTIONDETAILS",
  GET_JOURNEYLIST: "GET_JOURNEYLIST",
  GET_PLANLIST: "GET_PLANLIST",
  GET_COLLECTIONLIST: "GET_COLLECTIONLIST",
  GET_EMPLOYEELIST: "GET_EMPLOYEELIST",
  JOURNEYDETAILS: "JOURNEYDETAILS",
  CHILDRENDEALERSHIPDETAILS: "GET_CHILDRENDEALERSHIPDETAILS"
};
